"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CheckoutBasket = void 0;
var _mui = require("@ori-ui/mui");
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _presentationHttp = require("@ori/presentation-http");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _components = require("./components");
var _constants = require("./constants");
var _contexts = require("./contexts");
var _logger2 = require("./logger");
var _jsxRuntime = require("react/jsx-runtime");
const CheckoutBasket = (param)=>{
    let { configuration, checkoutSummary } = param;
    const { tenant } = (0, _environment.useEnvironment)();
    const { customerId, token } = (0, _auth.useToken)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.StrictMode, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
            logger: _logger2.mainLogger,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
                areaName: "".concat(_constants.APP_NAME, "-boundary"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
                    team: _testidGenerator.Team.Checkout,
                    project: _constants.APP_NAME,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
                        namespace: _constants.translationsNamespace,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_contexts.CheckoutBasketProvider, {
                            value: configuration,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.ThemeProvider, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationHttp.HeadersProvider, {
                                    sourceAppName: _constants.PACKAGE_NAME,
                                    tenant: tenant,
                                    customerId: customerId,
                                    token: token,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Step1, {
                                        checkoutSummary: checkoutSummary
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
exports.CheckoutBasket = CheckoutBasket;
